const backdropBlur = {
    name: "backdrop-blur",
    path: "/backdrop-blur",
    title: "backdrop-blur",
    description: "Utilities for applying backdrop-blur filter effects to element's backdrop:",
    value: {
        'backdrop-filter': {
            'backdrop-blur-xs': 'blur(var(--backdrop-blur-xs))',
            'backdrop-blur-sm': 'blur(var(--backdrop-blur-sm))',
            'backdrop-blur-md': 'blur(var(--backdrop-blur-md))',
            'backdrop-blur-lg': 'blur(var(--backdrop-blur-lg))',
            'backdrop-blur-xl': 'blur(var(--backdrop-blur-xl))',
            'backdrop-blur-2xl': 'blur(var(--backdrop-blur-2xl))',
            'backdrop-blur-3xl': 'blur(var(--backdrop-blur-3xl))',
            'backdrop-blur-none': '',
            'backdrop-blur-[<value>]': 'backdrop-blur(<value>);',
        },
    },
    exampleData: [
        {
            "title": "backdrop-blur-sm,backdrop-blur-lg",
            "description": "to backdrop-blur an element:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-4 gap-10 !bg-none !border-0 pt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg backdrop-blur-none",
                        "text": "backdrop-blur-none",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg backdrop-blur-sm",
                        "text": "backdrop-blur-sm",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg backdrop-blur-lg",
                        "text": "backdrop-blur-lg",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg backdrop-blur-[15px]",
                        "text": "backdrop-blur-[15px]",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<img class="backdrop-blur-none" src="/img/mountains.jpg" />
<img class="backdrop-blur-sm" src="/img/mountains.jpg" />
<img class="backdrop-blur-lg" src="/img/mountains.jpg" />
<img class="ackdrop-blur-[15px]" src="/img/mountains.jpg" />`
            }
        }
    ]
};

export default backdropBlur;